<template>
  <v-container grid-list-md text-xs-left align-center>
    <v-layout row wrap>
      <v-flex xs12>
        <p class="subheading font-weight-regular">
          ハイウェイバスドットコムの予約が空くのを待ちます。
        </p>
      </v-flex>

      <v-flex xs6>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-select :items="targetDateItems" label="乗車日を選択" v-model="targetDateSelect"
            :rules="[v => !!v || 'Item is required']" required></v-select>
        </v-form>
      </v-flex>

      <v-flex xs12>
        <v-btn :disabled="loading" small color="primary" dark @click="onClickSearch">検索</v-btn>
      </v-flex>

      <v-flex v-if="loading" xs12>
        <div class="text-xs-center">
          <v-progress-circular indeterminate color="primary" class="py-5"></v-progress-circular>
        </div>
      </v-flex>
      <v-flex v-else xs12>
        <v-layout v-for="item in timeList" :key="item.time" row wrap>
          <v-flex xs7>{{item.target_string}}</v-flex>
          <v-flex xs2 class="text-xs-center">{{item.state}}</v-flex>
          <v-flex xs3 class="text-xs-center">
            <template v-if="item.state == '×'">
              <v-btn v-if="item.waiting" small disabled >空き待ち中</v-btn>
              <v-btn v-else small color="green" dark @click="onClickWait(item.target_string)">待つ！</v-btn>
            </template>
            <a v-else :href="baseUrl + '&bordingDate=' + targetDateSelect" target="_blank">サイトへGO！</a>
            <!-- <v-btn v-else small color="gray">サイトへGO！</v-btn> -->
          </v-flex>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
      </v-flex>


      <v-dialog v-model="dialogOpened" max-width="500px">
        <v-card>
          <v-card-title>
            <span>通知</span>
          </v-card-title>
          <v-card-text>
            ショートメールを送信しました。<br/>
            空席が出たらショートメールで通知します。
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" flat @click="dialogOpened=false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    
    data: () => ({
      baseUrl: "https://www.highwaybus.com/gp/reservation/rsvPlanList?mode=search&route=8&lineId=150&onStationCd=001&offStationCd=233&datePicker01=20190404&danseiNum=1&zyoseiNum=0",
      
      // セレクトボックス情報
      targetDateSelect: null,
      targetDateItems:  [],
      timeList: [
        // {target_string: " 3/29 19:25 発 - 3/29 22:33 着予定 ", state: "〇" },
        // {target_string: " 3/29 19:25 発 - 3/29 22:33 着予定 ", state: "×" },
        // {target_string: " 3/29 19:25 発 - 3/29 22:33 着予定 ", state: "△" },
        // {target_string: " 3/29 19:25 発 - 3/29 22:33 着予定 ", state: "△" },
        // {target_string: " 3/29 19:25 発 - 3/29 22:33 着予定 ", state: "〇" }
      ],

      valid: true,

      loading: false,

      dialogOpened: false
      
    }),
    
    methods: {
      targetDateItemsFunc: function () {
        var date = new Date();

        date.setDate(date.getDate() - 1);
        let dateList = [];
        for (var i = 0; i < 30; i++) {
          date.setDate(date.getDate() + 1);

          var year = date.getFullYear();
          var month = "00" + (date.getMonth() + 1);
          var day = "00" + date.getDate();

          month = month.substr(month.length - 2);
          day = day.substr(day.length - 2);
          dateList.push({text: month + "/" + day, value: year + "" + month + "" + day})
        }
        
        return dateList;
      },

      /**
       * 検索ボタンクリック
       */
      onClickSearch: function() {

        console.log(this.targetDateSelect)
        if (!this.$refs.form.validate()) {
          return;
        }

        this.loading = true;

        axios.request({
          url: "https://u3mao1ymrb.execute-api.us-west-2.amazonaws.com/dev/bus-list",
          method : "post",
          headers : { "x-api-key": "0tmbOrub3e17H8nfP4GF891wYC9DwGnw6960nIfZ" },
          data: {"date" : this.targetDateSelect}
        }).then(response => {
          this.loading = false;
          if (response.status != 200) {
            return;
          }

          for (let i = 0; i < response.data.timeList.length; i++) {
            let timeData = response.data.timeList[i];

            // すでに待ち中のデータはステータスを変更
            if (response.data.waitData != null) {
              timeData.waiting = response.data.waitData.state != "1" && timeData.target_string == response.data.waitData.target_string;
            }
          }

          this.timeList = response.data.timeList;
          console.log(response)
        }).catch(error => {
          this.loading = false;
          console.log(error)
        });
      },

      /**
       * 待つボタンクリック
       */
      onClickWait: function(targetTime) {
        console.log(targetTime);

        this.loading = true;
        axios.request({
          url: "https://u3mao1ymrb.execute-api.us-west-2.amazonaws.com/dev/insert-wate",
          method : "post",
          headers : { "x-api-key": "0tmbOrub3e17H8nfP4GF891wYC9DwGnw6960nIfZ" },
          data: {
              "target_ymd" : this.targetDateSelect,
              "target_string": targetTime
            }
        }).then(response => {
          this.loading = false;
          this.dialogOpened = true;
          if (response.status != 200) {
            return;
          }

          for (let i = 0; i < this.timeList.length; i++) {
            let timeData = this.timeList[i];

            // すでに待ち中のデータはステータスを変更
            if (response.data != null) {
              timeData.waiting = response.data.state != "1" && timeData.target_string == response.data.target_string;
            }
          }

        }).catch(error => {
          this.loading = false;
          console.log(error)
        });
      }
    },

    created: function () {
      this.targetDateItems = this.targetDateItemsFunc();
    }
  }
</script>

<style>

</style>
